import Constants from "common/constant";

// 暫定: アルゴリズムまなぼの画像を流用。
// 将来 course_soft_sokoban.webp / course_sokoban_start.webp に差し替える際は
// 当ファイルのパスのみ更新すれば全体に反映される。
export const SokobanCassetteAssets = {
  cassette: `${Constants.assetHost}/assets/images/course_soft_algorithm.webp`,
  start: `${Constants.assetHost}/assets/images/course_algorithm_start.webp`,
};
